// extracted by mini-css-extract-plugin
module.exports = {"SearchWrapper":"SearchWrapper_SearchWrapper__1Ovou","SearchWrapperSmall":"SearchWrapper_SearchWrapperSmall__2lhXu","Content":"SearchWrapper_Content__xIOQl"};